<label class="form-label">Pojazd</label>

<form [formGroup]="selectedVehicleWithRange" class="d-flex justify-content-between align-items-end">
	<mat-form-field appearance="outline" class="w-25">
		<mat-label>Wybierz pojazd</mat-label>
		<input type="text" matInput formControlName="selectedVehicle" [matAutocomplete]="auto" />
		<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
			@for (option of filteredVehicles(); track option.id) {
				<mat-option [value]="option"
					>{{ option.name }}
					@if (!!option.seats) {
						({{ option.seats }})
					}
					- {{ option.status_name }}</mat-option
				>
			}
		</mat-autocomplete>
		@if (selectedVehicleWithRange.get('selectedVehicle').invalid) {
			<mat-error>Pojazd jest wymagany</mat-error>
		}
	</mat-form-field>

	<form class="container" formGroupName="range">
		<div class="row g-3 align-items-center">
			<div class="col-md-3">
				<mat-form-field class="w-100" appearance="outline">
					<mat-label>Od</mat-label>
					<input
						matInput
						formControlName="dateFrom"
						[min]="availableDateRange().min"
						[max]="availableDateRange().max"
						[matDatepicker]="pickerFrom"
					/>
					@if (
						availableDateRange().min >= availableDateRange().max &&
						!!availableDateRange().min &&
						!!availableDateRange().max
					) {
						<mat-hint class="text-success">
							Cały zakres wydarzenia został uzupełniony <i class="fas fa-check-circle"></i>
						</mat-hint>
					}
					@if (selectedVehicleWithRange.get('range').get('dateFrom').invalid) {
						<mat-error>Uzupełnij poprawnie date</mat-error>
					}
					<mat-datepicker-toggle matIconSuffix [for]="pickerFrom"></mat-datepicker-toggle>
					<mat-datepicker #pickerFrom></mat-datepicker>
				</mat-form-field>
			</div>

			<div class="col-md-3">
				<mat-form-field class="w-100" appearance="outline">
					<input formControlName="timeFrom" matInput type="time" />
					@if (selectedVehicleWithRange.get('range').get('timeFrom').invalid) {
						<mat-error>Uzupełnij poprawnie czas</mat-error>
					}
				</mat-form-field>
			</div>

			<div class="col-md-3">
				<mat-form-field class="w-100" appearance="outline">
					<mat-label>Do</mat-label>
					<input
						matInput
						formControlName="dateTo"
						[min]="availableDateRange().min"
						[max]="availableDateRange().max"
						[matDatepicker]="pickerTo"
					/>
					@if (
						availableDateRange().min >= availableDateRange().max &&
						!!availableDateRange().min &&
						!!availableDateRange().max
					) {
						<mat-hint class="text-success">
							Cały zakres wydarzenia został uzupełniony <i class="fas fa-check-circle"></i>
						</mat-hint>
					}
					@if (selectedVehicleWithRange.get('range').get('dateTo').invalid) {
						<mat-error>Uzupełnij poprawnie date</mat-error>
					}
					<mat-datepicker-toggle matIconSuffix [for]="pickerTo"></mat-datepicker-toggle>
					<mat-datepicker #pickerTo></mat-datepicker>
				</mat-form-field>
			</div>

			<div class="col-md-3">
				<mat-form-field class="w-100" appearance="outline">
					<input formControlName="timeTo" matInput type="time" />
					@if (selectedVehicleWithRange.get('range').get('timeTo').invalid) {
						<mat-error>Uzupełnij poprawnie czas</mat-error>
					}
				</mat-form-field>
			</div>
		</div>
	</form>
</form>

<div class="d-flex justify-content-end">
	<button
		[disabled]="availableDateRange().min >= availableDateRange().max"
		(click)="addVehicle()"
		mat-flat-button
		color="primary"
	>
		Dodaj
	</button>
</div>

@if (addedVehicles().length) {
	<table mat-table [dataSource]="addedVehicles()">
		<ng-container matColumnDef="fullName">
			<th mat-header-cell *matHeaderCellDef>Pojazd</th>
			<td mat-cell *matCellDef="let element; let i = index">
				<mat-form-field subscriptSizing="dynamic" appearance="outline" class="w-49 py-2">
					<mat-label>Wybierz pojazd</mat-label>
					<input
						type="text"
						matInput
						[ngModel]="element"
						(ngModelChange)="changeVehicle(i, $event)"
						[matAutocomplete]="auto"
						[disabled]="editable()"
					/>
					<mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
						@for (option of filteredVehicleToArray(); track option.id) {
							<mat-option [value]="option"
								>{{ option.name }}
								@if (!!option.seats) {
									({{ option.seats }})
								}
								- {{ option.status_name }}</mat-option
							>
						}
					</mat-autocomplete>
				</mat-form-field>
			</td>
		</ng-container>

		<ng-container matColumnDef="dateRange">
			<th mat-header-cell *matHeaderCellDef>Zakres</th>
			<td mat-cell *matCellDef="let element">
				{{ element.dateFrom | date: 'dd.MM.yyyy, HH:mm' }} - {{ element.dateTo | date: 'dd.MM.yyyy, HH:mm' }}
			</td>
		</ng-container>

		<ng-container matColumnDef="remove">
			<th mat-header-cell *matHeaderCellDef></th>
			<td mat-cell *matCellDef="let element; let i = index">
				<button mat-flat-button color="warn" (click)="removeVehicleByIndex(i)">Usuń</button>
			</td>
		</ng-container>

		<tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
		<tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
	</table>
}
